import { useErrorStore } from '@/stores/errorStore.ts'
import { isNetworkErrorEditRedirectErrorPage, NetworkError } from '@/utilities/stores'

const useNetworkError = (callback: (() => Promise<void>) | (() => void)) => {
  return async (networkError: unknown): Promise<void> => {
    if (networkError instanceof NetworkError) {
      if (isNetworkErrorEditRedirectErrorPage(networkError)) {
        const errorStore = useErrorStore()
        errorStore.setError('500')
      } else {
        await callback()
      }
    }
  }
}

export { useNetworkError }
